export enum StartOfWeek {
  Monday = "monday",
  Sunday = "sunday",
}

export type DateFormat =
  | "YYYY-MM-DD HH:mm"
  | "MM-DD-YYYY HH:mm"
  | "DD-MM-YYYY HH:mm";

export const availableDateFormats: DateFormat[] = [
  "YYYY-MM-DD HH:mm",
  "MM-DD-YYYY HH:mm",
  "DD-MM-YYYY HH:mm",
];

export const DEFAULT_COVER_URL =
  "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0015_Lager%203.jpg?alt=media&token=497e59d4-7a83-439c-add1-a29dfe294930";
